import Database from '../types/Database'

/**
 * Filters bookings for a specific date
 */
export const filterBookingsForDate = (
  bookings: Database.Booking[] | undefined,
  targetDate: Date
): Database.Booking[] => {
  if (!bookings) return []

  // Create date-only version of target date to avoid timezone issues
  const targetDateOnly = new Date(
    targetDate.getFullYear(),
    targetDate.getMonth(),
    targetDate.getDate()
  )

  return bookings.filter(booking => {
    if (!booking.forDate) return false

    let bookingDate: Date

    if (
      booking.forDate &&
      typeof booking.forDate === 'object' &&
      'seconds' in booking.forDate
    ) {
      // Firestore Timestamp
      bookingDate = new Date((booking.forDate as any).seconds * 1000)
    } else {
      // Already a JS Date
      bookingDate = new Date(booking.forDate)
    }

    // Create date-only version of booking date to avoid timezone issues
    const bookingDateOnly = new Date(
      bookingDate.getFullYear(),
      bookingDate.getMonth(),
      bookingDate.getDate()
    )

    return bookingDateOnly.getTime() === targetDateOnly.getTime()
  })
}

/**
 * Checks if a user has a booking in the provided bookings array
 */
export const hasUserBooking = (
  bookings: Database.Booking[] | undefined,
  userId: string | undefined
): boolean => {
  if (!bookings || !userId) return false
  return bookings.some(booking => booking.uid === userId)
}
